import {
  get,
  saveOrModify
} from '@/services/internal/facility/config/AlcDiffHandlemodeConfig';

export default {
  namespace: 'alcDiffHdanleModeConfig',

  state: {
    data: [],
    formData: []
  },

  effects: {
    *saveOrModify({ payload, callback }, { call, put }) {
      const response = yield call(saveOrModify, payload);
      if (callback) callback(response);
    },

    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      yield put({
        type: 'save',
        payload: response.data
      });
      if (callback) callback(response);
    },

    *getFormList({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (response && response.success) {
        let data = [];
        if (Array.isArray(response.data)) {
          response.data.forEach(e => {
            let modeTypes = e.modeTypes ? e.modeTypes.split(',') : [];
            if (modeTypes.length > 0) {
              modeTypes.forEach((item, id) => {
                data.push({
                  ...e,
                  modeType: item,
                  isDefault: e.defaultModeType === item ? true : false
                })
              })
            } else {
              data.push({
                ...e,
                modeType: 'UNKNOWN',
                isDefault: true
              })
            }
          })
        }
        yield put({
          type: 'saveForm',
          payload: data
        });
        if (callback) callback(data)
      }
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload
      };
    },
    saveForm(state, action) {
      return {
        ...state,
        formData: action.payload
      }
    }
  }
}
